import React from 'react';
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";
import { RTSData } from "./RTSData";

const RTSView = (props) => {
        return (
            <FiltersDataContextProvider>
              <FiltersStateContextProvider context = {props.match.params.context}>
                <ViewDataContextProvider>
                  <RTSData/>
                </ViewDataContextProvider>
              </FiltersStateContextProvider>   
            </FiltersDataContextProvider>

        )
}

export default RTSView;


// WEBPACK FOOTER //
// ./src/components/rts/RTSView.js